var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_vm._v(" nav ")]),_c('v-col',{staticClass:"pa-6",attrs:{"cols":"9"}},[_vm._v(" content ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }